import { GuidT } from '@/types/common';

export const ADVICES: string[] = [
    'Один предмет одежды на фото',
    'Изделие должно быть полностью видно',
    'Однотонный контрастный фон',
    'Хорошее освещение без теней',
];

export const IMAGE_GUID: GuidT = '6c3f4260-70fa-48cd-994c-a26a6dbe93fb';
